module.exports = __webpack_public_path__ + "static/media/collapseMapIcon.4cc92646.svg";